import React, { useState } from "react";
import { connect } from "react-redux";
import { GetFormatedDateWithTime } from '../../../common/Utils'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import InvoicesSearchResult from "./InvoicesSearchResult";
import InvoiceSearchForm from "./InvoiceSearchForm";
const SearchInvoices = (props) => {
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const getDataUrl = "wm/UpdateInvoice/SearchInvoices";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState('Update Invoices');
    var accessToken = props.oidc.user.access_token;
    const searchPanelData = (resultData) => {
        setSearchPanelStatus(resultData);
      };
    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                CustomerId: function () {
                    return formFields.RCustomer;
                },
                CustomerName: function () {
                    return formFields.CustomerName;
                },
                InvoiceNumber: function () {
                    return formFields.InvoiceNumber;
                },
                InvoiceDate: function () {
                    return GetFormatedDateWithTime(formFields.InvoiceDate);
                },
                ReferenceNumber: function () {
                    return formFields.ReferenceNumber;
                },
                Frequence: function () {
                    return formFields.Frequence;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (formFields) => {
        var resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <InvoiceSearchForm pageTitle={pageTitle} searchPanelData={searchPanelData} searchData={searchData} />
                        <InvoicesSearchResult data={dataSource} searchPanelStatus={searchPanelStatus} gridKey={"693E3515-7F1C-4A62-BB28-EBCA0DBEBF0D"} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SearchInvoices);